import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../utils/models/user.model';
import { API_BASE_URL } from './tokens';

@Injectable()
export class UserApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  private userUrl: string;

  constructor() {
    const baseUrl = this.baseUrl;
    this.userUrl = baseUrl + '/users';
  }

  public get$(): Observable<User[]> {
    return this.http.get<User[]>(this.userUrl);
  }

  public delete$(id: string): Observable<boolean> {
    return this.http.delete(`${this.userUrl}/${id}`).pipe(map((result: boolean) => result));
  }

  public create$(user: Partial<User>): Observable<User> {
    return this.http.post<User>(this.userUrl, user);
  }

  public update$(user: User): Observable<User> {
    return this.http.put<User>(`${this.userUrl}/${user.id}`, user);
  }

  public getUserById$(id: string): Observable<User> {
    return this.http.get<User>(`${this.userUrl}/${id}`);
  }

  public exportUsersAsCSV(): Observable<Blob> {
    return this.http.get(`${this.userUrl}/export/csv`, {
      responseType: 'blob',
    });
  }
}
